import { render, staticRenderFns } from "./DollarIcon.vue?vue&type=template&id=79e588e3&scoped=true&"
import script from "./DollarIcon.vue?vue&type=script&lang=js&"
export * from "./DollarIcon.vue?vue&type=script&lang=js&"
import style0 from "./DollarIcon.vue?vue&type=style&index=0&id=79e588e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e588e3",
  null
  
)

export default component.exports